import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class PhysicalCountDetailService extends DatabaseGwService{

  URL_PATH: string = "/physical-count-details";
}
